export const isCordova = (document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1);
